import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Step } from '@platform/base';
import CompMeta from '../../meta/LowCodeComponents/Step';
const statusEnum = ["wait", "process", "finish", "error"];
/**
 * @class NCStep
 * @column 1
 * @compType 1
 * @canAppend false
 * @path LowCodeComponents.NCStep
 * @label 步骤条
 *
 */
class NCStep extends Component {
    constructor(props) {
        super(props);
    }
    static propTypes = {
         /**
         * @title 组件标识
         * @description 组件标识
         */
          moduleId: PropTypes.string.isRequired,
        /**
         * @title 当前step的状态
         * @description 当前step的状态
         * @enumNames ['等待', '进行中','完成','错误']
         */
        status: PropTypes.oneOf(statusEnum),
        /**
         * @title 标题
         * @description 标题
         */
        title: PropTypes.string,
        /**
         * @title 描述
         * @description 描述
         */
        description: PropTypes.string,
        /**
        * @title 图标
        * @description 图标
        */
        icon: PropTypes.string,
    }
    static getCompMeta = () => {
        return CompMeta;
    }

    static defaultProps = {
        disabled: false
    }

    render() {
        return (
            <Step {...this.props}>{this.props.children}</Step>
        )
    }
}

export default NCStep;
